import { Blogs_API } from "../../../../utility/API"

//************************************//
export const _getPolicies = (callback, callbackErr) => {
  Blogs_API.get(`public/view_privacy_policy`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (error) {
      callbackErr(error.response.data)
    })
}
//************************************//
